<template>
  <header>
    <div class="bg-[#0A142F] w-full h-[60px] flex items-center justify-start md:px-[8%] px-[3%]">
      <img src="@/assets/img/logo_bluedotai_s.png" alt="bluedot-logo" class="w-[222px] h-auto invert">
    </div>
  </header>
</template>
